import { Component, OnInit, HostListener, ViewChild } from '@angular/core';
import { AppSettings } from '../../app.settings';
import { Settings } from '../../app.settings.model';
import { games, squares, squaresArray } from './squarewinners.model';
// import { SquaresService } from './squares.service';

import { AngularFireAuth } from "@angular/fire/compat/auth";

import { FirebaseFunctions } from '../../shared/firebase/firebasefunctions.service';


@Component({
  selector: 'app-squarewinners',
  templateUrl: './squarewinners.component.html',
  styleUrls: ['./squarewinners.component.scss'],
  providers: [ ]
})
export class SquareWinnersComponent implements OnInit {
  @ViewChild('sidenav') sidenav: any;
  public settings: Settings;
  public userImage = 'assets/img/users/user.jpg';
  // public squaress: Array<Squares>;
  // public talks: Array<Squares>;
  public sidenavOpen:boolean = true;
  // public currentSquares:Squares;
  public newMessage:string;

  
  OneThru9 = [6, 1, 3, 5, 0, 8, 9, 7, 4, 2];
  zeros = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
  
  // games = games;
  games;
  squares = squares;
  data;
  data2;
  newData = [];
  updateGames = false;
  updateSquares = false;
  editBoxes = true;
  squaresArray = squaresArray
  
  gamesId = 'mondaynight2022';
  // gamesId = 'superbowl2021';
  squaresId = 'baxterdads2022';
  // squaresId = 'baxterDads2021Superbowl';
  tiles =[]

  constructor(public appSettings:AppSettings, 
    // private squaresService:SquaresService, 
    private ff: FirebaseFunctions, private afAuth: AngularFireAuth,) { 
    this.settings = this.appSettings.settings; 
    
  }

  async getAllGames(){
    const winners = [];
    const ids = []
      const snapshot = await this.ff.getAllData_IfLoggedIn('games').subscribe(data => {
        data.forEach(doc => {
          let id = doc.id;
          let val = doc.data();
          val['id'] = id
          if (id.includes('mondaynight2022_')) {
            // console.log(val)
            for (let i = 0; i < val.data.length; i++) {
              const element = val.data[i];
              if (element.finalScore.HomeTeam !== 'A') {
                if (ids.indexOf(element.Date) === -1) {
                  ids.push(element.Date)
                  // console.log(val)
                  let newSquares = []
                  // console.log(element.finalScore.HomeTeam.toString().slice(-1));
                  element.finalScore.HomeTeam = element.finalScore.HomeTeam.toString().slice(-1);
                  element.finalScore.AwayTeam = element.finalScore.AwayTeam.toString().slice(-1);
                  element.newSquareData = this.squares
                  for (let j = 0; j < this.squares.length; j++) {
                    const squares = this.squares[j];
                    const val = {
                      "id": element.yValues[j],
                      [element.yValues[0]]: squares["0"],
                      [element.yValues[1]]: squares["1"],
                      [element.yValues[2]]: squares["2"],
                      [element.yValues[3]]: squares["3"],
                      [element.yValues[4]]: squares["4"],
                      [element.yValues[5]]: squares["5"],
                      [element.yValues[6]]: squares["6"],
                      [element.yValues[7]]: squares["7"],
                      [element.yValues[8]]: squares["8"],
                      [element.yValues[9]]: squares["9"],
                    }
                    newSquares.push(val)
                  }
                  element.newSquareData = newSquares
                  winners.push(element)

                }

              }
            }
          }
        })
        // console.log(ids)
        // this.data2 = winners;
        this.games = winners;

        // console.log(winners)
      }
    )
    // .map(data => {
      // this.runData2(winners);
    // })
  }

  ngOnInit() {
    // this.squaress = this.squaresService.getSquaress(); 
    if(window.innerWidth <= 768){
      this.sidenavOpen = false;
    }    
    // this.runData();
    this.ff.getDataById('squares', this.squaresId)
    .subscribe(data => {
      // console.log(data);
      this.data = data;
      this.squares = this.data.data;
      // console.log(this.squares)
      this.getAllGames();
    });
  } 


  @HostListener('window:resize')
  public onWindowResize():void {
    (window.innerWidth <= 768) ? this.sidenavOpen = false : this.sidenavOpen = true;
  }


  runData2(games) {
    for (let i = 0; i < games.length; i++) {
      const element = games[i];
      console.log('123', element)
    }
    for (let i = 0; i < games.length; i++) {
      const element = games[i];
      let newSquares = []
      console.log(element.finalScore.HomeTeam.toString().slice(-1));
      element.finalScore.HomeTeam = element.finalScore.HomeTeam.toString().slice(-1);
      element.finalScore.AwayTeam = element.finalScore.AwayTeam.toString().slice(-1);
      element.newSquareData = this.squares
      for (let j = 0; j < this.squares.length; j++) {
        const squares = this.squares[j];
        console.log(squares)
        const val = {
          "id": element.yValues[j],
          [element.yValues[0]]: squares["0"],
          [element.yValues[1]]: squares["1"],
          [element.yValues[2]]: squares["2"],
          [element.yValues[3]]: squares["3"],
          [element.yValues[4]]: squares["4"],
          [element.yValues[5]]: squares["5"],
          [element.yValues[6]]: squares["6"],
          [element.yValues[7]]: squares["7"],
          [element.yValues[8]]: squares["8"],
          [element.yValues[9]]: squares["9"],
        }
        newSquares.push(val)
      }
    element.newSquareData = newSquares
  }
  // console.log(JSON.stringify(games));
  // console.log(JSON.stringify(newgames));


  }
   // TODO if date past date of game (or a few days after) then remove game from rendering
  // TODO set up auto way to randomize numbers
  // TODO set up way to auto pull in games
  // TODO set up way for people to buy squares and dynamically assign squares

}